import store from '@/store';
import { DirectiveOptions } from 'vue';
import { isNullish } from '@tencent/v-common-utils';
import { preventClick } from '@/utils';
import { State } from '@/store/modules/account';
import { AccountType } from '@/types/account';

/**
 * 校验账户是否支持入口
 *
 * @param {*} { supportAccountType } 限制的账户类型，不传入则不限制
 * @param {*} { supportCapability } 限制的能力，不传入则不限制， supportAccountType、supportCapability任意一个通过则通过
 * @param {*} { text } 校验不通过之后，弹窗的提示信息
 * @return {*}  {DirectiveOptions}
 */
const directiveOption: DirectiveOptions = {
  inserted(el: HTMLElement, binding) {
    const value = binding.value as {
      [key: string]: string | AccountType;
    };
    const supportAccountType = value?.supportAccountType as AccountType;
    const supportCapability = value?.supportCapability as string;
    if (!value || (isNullish(supportAccountType) && isNullish(supportCapability))) {
      return;
    }
    const {
      type,
      capability,
    } = ((store.state as any)?.account as State)?.accountInfo;

    let elementValid = true;
    if (!isNullish(supportAccountType) && !isNullish(type) && type !== supportAccountType) {
      elementValid = false;
    }
    if (!isNullish(supportCapability) && capability?.[supportCapability] !== true) {
      elementValid = false;
    }
    if (!elementValid) {
      preventClick(el, (value.text as string));
    }
  },
};

export default directiveOption;
